/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { InboxMessageResponseDirection } from './inboxMessageResponseDirection';

/**
 * One email inside ``ThreadDetail.messages``.
 */
export interface InboxMessageResponse {
  id: string;
  direction: InboxMessageResponseDirection;
  from_address: string;
  from_name?: string | null;
  from_avatar_url?: string | null;
  to_addresses?: string[];
  cc_addresses?: string[];
  bcc_addresses?: string[];
  subject?: string | null;
  body_html?: string | null;
  body_text?: string | null;
  provider_sent_at: string;
  delivered_at?: string | null;
  bounced_at?: string | null;
  bounce_reason?: string | null;
  is_sending?: boolean;
}
